/**
 * Utility for masking phone and sensitive numbers in Dashboard views
 * Example: "9876543210" -> "XXXXXX3210"
 */
export function maskMobileNumber(phone) {
  if (!phone) return "";
  const str = String(phone).trim();
  const digits = str.replace(/\D/g, "");
  if (digits.length <= 4) return "******";
  const last4 = digits.slice(-4);
  const maskedCount = Math.max(digits.length - 4, 6);
  return `${"X".repeat(maskedCount)}${last4}`;
}
